module.exports = __webpack_public_path__ + "img/not-found.2056c908.png";